import { makeStyles } from '@material-ui/core/styles';

const useStyles = () =>
  makeStyles(() => ({
    sectionWrapper: {
      background: 'none',
      paddingTop: '50px'
    },
    sectionLabel: {
      marginBottom: '15px'
    },
    buttonContainer: {
      marginTop: '25px',
      '& button:nth-child(2)': {
        marginLeft: '37px'
      }
    },
    vizContainer: {
      overflow: 'auto',
      '& iframe': {
        maxWidth: 'none'
      }
    }
  }));
export default useStyles;
